<template lang='pug'>
//- Course-Menu-Item
router-link(:to='`/course/${itemData.course_id}`' :class='$style[`cc-course-content-item-wrap`]')
  figure(
    v-if='itemData.photo_cover'
    :class='$style[`cc-course-content-item-photo`]')
    img(:src='`${SERVER_STATIC_URL}media/${itemData.photo_cover}`' width='100%')
  figure(
    v-else
    :class='$style[`cc-course-content-item-photo`]'
    :style='`background-image: url(${SERVER_STATIC_URL}media/originSrc/noimage.webp)`')

  div(:class='$style[`cc-course-content-item-describe`]')
    header.font-medium(:class='$style[`cc-course-content-item-title`]') {{ itemData.title }}
    ul(:class='$style[`cc-course-content-item-tag`]')
      li.bg-doctor-theme.font-white-theme(
        v-if='itemData.content_limit === `free`'
        :class='$style[`cc-course-content-item-tag-li`]') 免費課程
      li(
        v-for='tags, index in transformTagStringToList(itemData.tags)'
        :class='$style[`cc-course-content-item-tag-li`]') {{ tags }}

    div(:class='$style[`cc-course-content-item-info`]')
      div(:class='$style[`cc-course-content-item-avatar`]')
        figure(:class='$style[`cc-course-content-item-avatar-photo`]')
          img(
            :src='`${SERVER_STATIC_URL}media/${itemData.author_thumbSrc}`'
            width='100%'
            height='100%')
        span(:class='$style[`cc-course-content-item-avatar-name`]') {{ itemData.author_name }}
    
    div(:class='$style[`cc-course-content-item-view`]')
      IconView(:size='22')
      span.font-bold {{ itemData.read_count }}

      

</template>

<script>
// import axios from 'axios';
// import { mapGetters, mapMutations } from 'vuex';
// import { debounce } from 'debounce';

import IconView from '../../icon/View';

export default {
  components: {
    IconView,
  },

  props: {
    itemData: {
      type: Object,
      default: {},
    },
  },

  // data() {
  //   return {
  //     pageSize: 10,
  //     pageIndex: 2,
  //     loadData: [],
  //     infiniteId: +new Date(),
  //   };
  // },

  // mounted() {},

  methods: {
    transformTagStringToList(string) {
      const tagArray = string.split(',');
      return tagArray;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //     // stateFlowBarFixed: 'global/exportFlowBarFixed',
  //     authJwtToken: 'user/exportUserJwtToken',
  //   }),
  // },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/course/courseMenuItem.scss';
</style>
